"use client";

import React from "react";
import { Instagram, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col items-center md:items-start gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col items-center md:items-start gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors duration-300 text-sm tracking-wide font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function EstateFooter() {
  return <section data-section-id="264906" id="estate-footer" className="dark bg-background text-foreground py-20 px-6 border-t border-border/10">
      <div className="max-w-6xl mx-auto flex flex-col items-center">
        {}
        <div className="mb-16">
          <Link to="/HomePage" className="inline-block transition-opacity hover:opacity-80">
            <WvcLogo className="h-16 w-auto text-foreground" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full text-center md:text-left">
          
          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              Heritage
            </h3>
            <MenuProvider menu_id="48">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-center">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              Connect
            </h3>
            <div className="flex gap-4">
              <Link to="#" className="p-3 rounded-md bg-muted/10 hover:bg-secondary/20 transition-colors text-muted-foreground hover:text-secondary" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="#" className="p-3 rounded-md bg-muted/10 hover:bg-secondary/20 transition-colors text-muted-foreground hover:text-secondary" aria-label="Pinterest">
                <Heart className="w-5 h-5" />
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col items-center md:items-end">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              The Estate
            </h3>
            <p className="font-serif text-2xl md:text-3xl text-secondary italic tracking-wide">
              Velvet Vineyards
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 pt-8 border-t border-border/10 w-full text-center text-xs tracking-wider text-muted-foreground/60 uppercase font-default">
          <p>&copy; {new Date().getFullYear()} Velvet Vineyards. Crafted by Velvet Vineyards. All rights reserved.</p>
        </div>
      </div>
    </section>;
}